import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { categoryMappingClient } from '../../../infrastructure/CategoryMappingClient';
import type { CategoryMappingUpsert } from '../../../models/CategoryMapping';

const CATEGORY_MAPPINGS_QUERY_KEY = ['categoryMappings'];

export const useCategoryMappings = () => {
  const queryClient = useQueryClient();

  const mappingsQuery = useQuery({
    queryKey: CATEGORY_MAPPINGS_QUERY_KEY,
    queryFn: () => categoryMappingClient.getAllMappings(),
    staleTime: 5 * 60 * 1000,
  });

  const saveMappingsMutation = useMutation({
    mutationFn: (mappings: CategoryMappingUpsert[]) => categoryMappingClient.saveMappings(mappings),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CATEGORY_MAPPINGS_QUERY_KEY });
    },
  });

  return {
    mappings: mappingsQuery.data ?? [],
    isLoading: mappingsQuery.isLoading,
    isError: mappingsQuery.isError,
    refetch: mappingsQuery.refetch,
    saveMappings: saveMappingsMutation.mutateAsync,
    isSaving: saveMappingsMutation.isPending,
  };
};
